var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"key_value"},[_c('p',{staticClass:"key_value--label text-uppercase"},[_vm._v(_vm._s(_vm.label))]),_vm._v(" "),_c('p',{staticStyle:{"word-break":"break-word"}},[(_vm.isUrl)?_c('a',{attrs:{"href":_vm.formattedValue,"target":"_blank"}},[_vm._v(_vm._s(_vm.formattedValue))]):[_vm._v(_vm._s(_vm.formattedValue))]],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }